'use client'

import { ProductAddMobile } from '@/components/common/product-card/product-add-mobile'
import { ImageHelper } from '@/lib/helpers/image.helper'
import Image from 'next/image'
import Link from 'next/link'
import { useProductCardContext } from './context/product-card-context'
import { ProductItemHeader } from './product-item-header'
import { ProductItemImages } from './product-item-images'
import { ProductItemSizes } from './product-item-sizes'

export const ProductItemThumbnail = () => {
  const { product, trackingClickProduct } = useProductCardContext()

  const handleClick = () => {
    trackingClickProduct()
  }

  return (
    <div className='group relative'>
      <Link
        href={product.href}
        className='block h-full w-full'
        data-tracking-level-99={`Product-item-${product.id}`}
        data-ga-tracking-label={product.href.split('/').pop()}
        onClick={handleClick}
        aria-label={`View details for ${product.title}`}
      >
        <ProductItemImages />

        {!product?.icon_thumbnail?.hide && product?.icon_thumbnail?.image && (
          <div className='absolute bottom-0 left-0 z-[1] h-auto w-full rounded-b-lg'>
            <Image
              src={ImageHelper.getImageUrl(
                product?.icon_thumbnail?.image,
                '585_663'
              )}
              width={433}
              height={62}
              alt={`${product.title} thumbnail image`}
              className='block h-auto w-full rounded-b-lg object-cover'
              loading='lazy'
            />
          </div>
        )}
        <ProductItemHeader />
      </Link>
      <div className='max-lg:hidden'>
        <ProductItemSizes />
      </div>
      <ProductAddMobile
        className={
          !product?.icon_thumbnail?.hide && product?.icon_thumbnail?.image
            ? 'bottom-12'
            : 'bottom-6'
        }
      />
    </div>
  )
}
